export const NEW_LOTTERY = 'NEW_LOTTERY';

export const FETCH_LOTTERY_SUCCESS = 'FETCH_LOTTERY_SUCCESS';

export const CREATE_LOTTERY_START = 'CREATE_LOTTERY_START';
export const CREATE_LOTTERY_SUCCESS = 'CREATE_LOTTERY_SUCCESS';
export const CREATE_LOTTERY_ERROR = 'CREATE_LOTTERY_ERROR';

export const UPDATE_LOTTERY_START = 'UPDATE_LOTTERY_START';
export const UPDATE_LOTTERY_SUCCESS = 'UPDATE_LOTTERY_SUCCESS';
export const UPDATE_LOTTERY_ERROR = 'UPDATE_LOTTERY_ERROR';

export const FETCH_LOTTERIES_START = 'FETCH_LOTTERIES_START';
export const FETCH_LOTTERIES_SUCCESS = 'FETCH_LOTTERIES_SUCCESS';
export const FETCH_LOTTERIES_ERROR = 'FETCH_LOTTERIES_ERROR';

export const LOTTERY_IMG_PREFIX = `${process.env.CDN}/img/lottery/`;
